export default "/kiban/_next/static/images/layer-eee9b6351692aac3742a24962e92e711.png";